import { render, staticRenderFns } from "./sideNotice-info.vue?vue&type=template&id=0bedd84f&scoped=true&"
import script from "./sideNotice-info.vue?vue&type=script&lang=js&"
export * from "./sideNotice-info.vue?vue&type=script&lang=js&"
import style0 from "./sideNotice-info.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sideNotice-info.vue?vue&type=style&index=1&id=0bedd84f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bedd84f",
  null
  
)

export default component.exports